<template>
  <div class="p-3">
    <div class="form-row">
      <div class="col">
        <input type="number"
               class="form-control"
               @focus="selectAll($event)"
               :placeholder="'Min ' + currency"
               v-model="priceMin"
               :aria-label="$translate('Ceres::Template.itemFilterPriceMin')">
      </div>
      <div class="col">
        <input type="number"
               class="form-control"
               @focus="selectAll($event)"
               :placeholder="'Max ' + currency"
               v-model="priceMax"
               :aria-label="$translate('Ceres::Template.itemFilterPriceMax')">
      </div>
      <div class="col">
        <button type="button" class="btn btn-primary btn-appearance form-control" :class="{'disabled': isDisabled}" v-tooltip
                data-toggle="tooltip" data-placement="top" @click="triggerFilter()" :title="$translate('Ceres::Template.itemApply')">
            <icon icon="check" :loading="isLoading"></icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import UrlService from "../../../services/UrlService";
import { mapState } from "vuex";

export default {
    data()
    {
        return {
            priceMin: "",
            priceMax: "",
            currency: App.activeCurrency
        };
    },

    mounted()
    {
        const urlParams = UrlService.getUrlParams(document.location.search);

        this.priceMin = urlParams.priceMin || "";
        this.priceMax = urlParams.priceMax || "";
    },

    computed:
    {
        isDisabled()
        {
            return (this.priceMin === "" && this.priceMax === "") ||
                (parseInt(this.priceMin) >= parseInt(this.priceMax)) ||
                this.isLoading;
        },

        ...mapState({
            isLoading: state => state.itemList.isLoading
        })
    },

    methods:
    {
        selectAll(event)
        {
            event.target.select();
        },

        triggerFilter()
        {
            if (!this.isDisabled)
            {
                window.localStorage.setItem("openFilterToolbar", true);
                this.$store.dispatch("selectPriceFacet", { priceMin: this.priceMin, priceMax: this.priceMax });
            }
        }
    }
}
</script>
